import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FerumPlayer from "./components/FerumPlayer";

const Landing = () => {
  return (
    <main
      className="min-h-screen w-full flex items-center justify-center px-4 sm:px-6 lg:px-10 py-6 sm:py-10 bg-slate-50"
      data-testid="landing-page"
    >
      <FerumPlayer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
